export default {
  key: 'A',
  suffix: 'sus2sus4',
  positions: [
    {
      frets: 'x00200',
      fingers: '000100'
    },
    {
      frets: '557757',
      fingers: '112314',
      barres: [5],
      capo: true
    },
    {
      frets: '5524xx',
      fingers: '341200'
    }
  ]
}
